<mat-expansion-panel
  [disabled]="isLocked"
  [class.filter-disabled]="isLocked"
  (opened)="panelOpenState = true"
  (closed)="panelOpenState = false"
  class="filter-panel"
>
  <mat-expansion-panel-header class="filter-header">
    <mat-panel-title class="filter-title-container">
      <app-pencil-icon
        *ngIf="isLocked"
        [name]="'lock_outline'"
        [type]="IconTypes.materialIcon"
        class="filter-title-icon"
      ></app-pencil-icon>
      <span class="filter-title">{{ title }}</span>
    </mat-panel-title>
    <mat-panel-description class="filter-description">
      <app-pencil-button
        *ngIf="panelOpenState && showClearButton"
        class="pencil-button small tertiary clear-btn"
        (click)="resetFilter($event)"
        [label]="'Clear' | translate"
      ></app-pencil-button>
      <app-pencil-button
        [icon]="panelOpenState ? 'expand_less' : 'expand_more'"
        [iconConfig]="{ type: IconTypes.materialIcon }"
        [disabled]="isLocked"
        class="pencil-button white small filter-icon"
      ></app-pencil-button>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <div class="filter-content" *ngIf="panelOpenState">
    <ng-content></ng-content>
  </div>
</mat-expansion-panel>
<div *ngIf="hasDivider" class="divider"></div>
